import { SelectProps } from "@cofano/cck/Select/Select";
import { LimitType } from "__generated__/graphql";
import { Select } from "@cofano/cck";
import { intl } from "LocaleWrapper";

const LimitTypeSelect = ({ value, onChange }: Omit<SelectProps<LimitType, false>, "fetchOptions">) => {
	return (
		<Select
			disableSearch
			fetchOptions={Object.values(LimitType)}
			getOptionLabel={(option) => intl.formatMessage({ id: `LIMIT_TYPE_${option}` })}
			value={value}
			onChange={onChange}
		/>
	);
};

export default LimitTypeSelect;
